import { BodyText, Callout } from "@/components/ui";
import { useParams } from "@tanstack/react-router";
import { SectionContent } from "../components/SectionContent";
import { SectionHeader } from "../components/SectionHeader";
import { Goal } from "./components/Goal";
import { GoalsSkeleton } from "./components/GoalsSkeleton";
import { useGetGoals } from "./network/useGoals";

export const Goals = () => {
  const { patientId } = useParams({ strict: false });
  const { data: goals, isLoading, isError } = useGetGoals(patientId);

  const noGoals = !isLoading && !isError && !goals?.length;

  return (
    <div className="w-full h-full flex flex-col">
      <SectionHeader title="Goals" />
      <SectionContent>
        {isLoading && <GoalsSkeleton />}
        {isError && (
          <div className="flex relative flex-col gap-2 px-3 py-2 w-full">
            <Callout
              className="w-full"
              variant="danger"
              title="Something went wrong!"
              description="Please refresh and try again."
            />
          </div>
        )}
        {noGoals && (
          <div className="flex py-2 w-full">
            <BodyText size="sm" textColor="tertiary">
              No goals set
            </BodyText>
          </div>
        )}
        {goals?.map((goal) => (
          <div key={goal.id}>
            <Goal goal={goal} />
          </div>
        ))}
      </SectionContent>
    </div>
  );
};
